var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: _vm.wrapClass }, [
    _vm.imageModel.HasCrop
      ? _c("div", { staticClass: "image-cover-wrap" }, [
          _c("picture", [
            _c("source", {
              attrs: {
                "data-srcset": _vm.imageModel.SrcSetWebP,
                type: "image/webp",
                "data-sizes": "auto"
              }
            }),
            _vm._v(" "),
            _c("source", {
              attrs: {
                "data-srcset": _vm.imageModel.SrcSet,
                type: _vm.imageModel.Type,
                "data-sizes": "auto"
              }
            }),
            _vm._v(" "),
            _c("img", {
              staticClass: "image-cover lazyload",
              style: _vm.imageModel.Style,
              attrs: {
                src: _vm.imageModel.Src,
                "data-src": _vm.imageModel.DataSrc,
                alt:
                  _vm.imageModel.AltText != null ? _vm.imageModel.AltText : "",
                "data-sizes": "auto"
              }
            })
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    !_vm.imageModel.HasCrop
      ? _c("img", {
          staticClass: "image-cover lazyload",
          style: _vm.imageModel.Style,
          attrs: {
            src: _vm.imageModel.Src,
            "data-src": _vm.imageModel.DataSrc,
            alt: _vm.imageModel.AltText != null ? _vm.imageModel.AltText : ""
          }
        })
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2c7a9831", { render: render, staticRenderFns: staticRenderFns })
  }
}